import { ref, watch } from "vue";

import useBonusomatLogoutData from "./use-bonusomat-logout-data";

const { logoutDefaultDrawData, loadDefaultDrawData } = useBonusomatLogoutData();

const logoutDrawRemainingSeconds = ref(0);
async function intervalDrawRemainingHandler() {
    if (logoutDrawRemainingSeconds.value > 0) {
        logoutDrawRemainingSeconds.value--;
    } else {
        await loadDefaultDrawData();
    }
}

let intervalDrawRemainingHandle = 0;
async function initDrawRemainingInterval() {
    if (intervalDrawRemainingHandle) {
        clearInterval(intervalDrawRemainingHandle);
    }

    intervalDrawRemainingHandle = window.setInterval(() => intervalDrawRemainingHandler(), 1000);
}

function initCountdowns(raffleRemaining: number) {
    logoutDrawRemainingSeconds.value = raffleRemaining;

    initDrawRemainingInterval();
}

watch(
    () => logoutDefaultDrawData.value?.drawRemainingSeconds,
    (newlogoutDrawRemainingSeconds) => {
        if (newlogoutDrawRemainingSeconds) {
            initCountdowns(newlogoutDrawRemainingSeconds);
        } else {
            clearInterval(intervalDrawRemainingHandle);
        }
    },
    { immediate: true }
);

export default function useBonusomatLogoutCountdown() {
    return {
        logoutDrawRemainingSeconds,
    };
}
